import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import ClientList from "src/components/Reviewer/Client/Client-list";

// ----------------------------------------------------------------------

export default function ReviewerClients() {
  return (
    <>
      <Helmet>
        <title> Clients </title>
      </Helmet>

      <Container maxWidth="xl">
        <ClientList Role="Reviewer" />
      </Container>
    </>
  );
}
